import {ApiError} from '@spa/api';

import {
    CompanyRegistrationFormErrorStatesEnum,
    PanelClientsAddCorporateResolverErrorStatesEnum
} from '../../enums/error-states';

import {PanelClientsAddCorporateMessages} from '../../../../../assets/messages';

export class PanelClientsAddCorporateTrait {
    private constructor() {
    }

    static getInitialErrorsMessages(errors: ApiError[]): string[] {
        return errors.map((error: ApiError) => {
            switch (error.status) {
                case PanelClientsAddCorporateResolverErrorStatesEnum.GetCompanyFailed:
                    return PanelClientsAddCorporateMessages.GetCompanyFailed.message;
                case PanelClientsAddCorporateResolverErrorStatesEnum.GetCountriesFailed:
                    return PanelClientsAddCorporateMessages.GetCountriesFailed.message;
                case PanelClientsAddCorporateResolverErrorStatesEnum.GetCountriesInvalidData:
                    return PanelClientsAddCorporateMessages.GetCountriesInvalidData.message;
                default:
                    return PanelClientsAddCorporateMessages.UnknownError.message;
            }
        });
    }

    static getFormErrorMessages(errors: ApiError[]): string[] {
        return errors.map((error: ApiError) => {
            switch (error.status) {
                case CompanyRegistrationFormErrorStatesEnum.GetCompanyFailed:
                    return PanelClientsAddCorporateMessages.GetCompanyExtendedFailed.message;
                case CompanyRegistrationFormErrorStatesEnum.CompanyRegistrationFailed:
                    return PanelClientsAddCorporateMessages.CompanyRegistrationFailed.message;
                case CompanyRegistrationFormErrorStatesEnum.TaxDetailsRegistrationFailed:
                    return PanelClientsAddCorporateMessages.TaxDetailsRegistrationFailed.message;
                case CompanyRegistrationFormErrorStatesEnum.TaxDetailsUpdateFailed:
                    return PanelClientsAddCorporateMessages.TaxDetailsUpdateFailed.message;
                case CompanyRegistrationFormErrorStatesEnum.VatDetailsUpdateFailed:
                    return PanelClientsAddCorporateMessages.VatDetailsUpdateFailed.message;
                case CompanyRegistrationFormErrorStatesEnum.UpdateResidentialAddressFailed:
                    return PanelClientsAddCorporateMessages.UpdateResidentialAddressFailed.message;
                case CompanyRegistrationFormErrorStatesEnum.ResidentialAddressRegistrationFailed:
                    return PanelClientsAddCorporateMessages.ResidentialAddressRegistrationFailed.message;
                case CompanyRegistrationFormErrorStatesEnum.UpdateMailingAddressFailed:
                    return PanelClientsAddCorporateMessages.UpdateMailingAddressFailed.message;
                case CompanyRegistrationFormErrorStatesEnum.MailingAddressRegistrationFailed:
                    return PanelClientsAddCorporateMessages.MailingAddressRegistrationFailed.message;
                case CompanyRegistrationFormErrorStatesEnum.UploadDocumentFileForRegistrationFailed:
                    return PanelClientsAddCorporateMessages.UploadDocumentFileForRegistrationFailed.message;
                case CompanyRegistrationFormErrorStatesEnum.DocumentRegistrationFailed:
                    return PanelClientsAddCorporateMessages.DocumentRegistrationFailed.message;
                case CompanyRegistrationFormErrorStatesEnum.UploadDocumentFileForUpdateFailed:
                    return PanelClientsAddCorporateMessages.UploadDocumentFileForUpdateFailed.message;
                case CompanyRegistrationFormErrorStatesEnum.UpdateDocumentFailed:
                    return PanelClientsAddCorporateMessages.UpdateDocumentFailed.message;
                case CompanyRegistrationFormErrorStatesEnum.UploadProofOfAddressDocumentFileForRegistrationFailed:
                    return PanelClientsAddCorporateMessages.UploadProofOfAddressDocumentFileForRegistrationFailed.message;
                case CompanyRegistrationFormErrorStatesEnum.ProofOfAddressDocumentRegistrationFailed:
                    return PanelClientsAddCorporateMessages.ProofOfAddressDocumentRegistrationFailed.message;
                case CompanyRegistrationFormErrorStatesEnum.UploadProofOfAddressDocumentFileForUpdateFailed:
                    return PanelClientsAddCorporateMessages.UploadProofOfAddressDocumentFileForUpdateFailed.message;
                case CompanyRegistrationFormErrorStatesEnum.UpdateProofOfAddressDocumentFailed:
                    return PanelClientsAddCorporateMessages.UpdateProofOfAddressDocumentFailed.message;
                case CompanyRegistrationFormErrorStatesEnum.UpdateStatusToPendingFailed:
                case CompanyRegistrationFormErrorStatesEnum.UpdateStatusToPendingAcceptanceFailed:
                case CompanyRegistrationFormErrorStatesEnum.UpdateStatusToForVerificationFailed:
                    return PanelClientsAddCorporateMessages.UpdateCompanyStatusFailed.message;
                default:
                    return PanelClientsAddCorporateMessages.UnknownError.message;
            }
        });
    }
}
